import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type SimulationSessionViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  statusValue?: { displayId: string; id: string } | null;
  status: string;
  modeValue?: { displayId: string; id: string } | null;
  mode: string;
  labelValue?: { displayId: string; id: string } | null;
  label: string;
  entryPipelineValue?: { displayId: string; id: string } | null;
  entryPipeline: string;
  scenarioValue?: { displayId: string; id: string } | null;
  scenario: string;
  resolvedGatesValue?: { displayId: string; id: string } | null;
  resolvedGates: string;
  currentGateValue?: { displayId: string; id: string } | null;
  currentGate: string;
  correlationIdValue?: { displayId: string; id: string } | null;
  correlationId: string;
  relatedEntityTypeValue?: { displayId: string; id: string } | null;
  relatedEntityType: string;
  relatedEntityIdValue?: { displayId: string; id: string } | null;
  relatedEntityId: string;
  startedAtValue?: { displayId: string; id: string } | null;
  startedAt: Date | null;
  completedAtValue?: { displayId: string; id: string } | null;
  completedAt: Date | null;
  triggeredByValue: { displayId: string; id: string } | null;
};

export const SimulationSessionViewForm: React.FC<SimulationSessionViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      status = "",
      mode = "",
      label = "",
      entryPipeline = "",
      scenario = "{}",
      resolvedGates = "{}",
      currentGate = "",
      correlationId = "",
      relatedEntityType = "",
      relatedEntityId = "",
      startedAt = null,
      completedAt = null,
      triggeredByValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupSimulationSessionLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={status}
                  label={langStore.SimulationSessionStatusLabel}
                />
                <ShowMultiLine
                  value={mode}
                  label={langStore.SimulationSessionModeLabel}
                />
                <ShowMultiLine
                  value={label}
                  label={langStore.SimulationSessionLabelLabel}
                />
                <ShowMultiLine
                  value={entryPipeline}
                  label={langStore.SimulationSessionEntryPipelineLabel}
                />
                <InputCodeEditor
                  value={scenario}
                  onChange={() => {}}
                  label={langStore.SimulationSessionScenarioLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={resolvedGates}
                  onChange={() => {}}
                  label={langStore.SimulationSessionResolvedGatesLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowMultiLine
                  value={currentGate}
                  label={langStore.SimulationSessionCurrentGateLabel}
                />
                <ShowMultiLine
                  value={correlationId}
                  label={langStore.SimulationSessionCorrelationIdLabel}
                />
                <ShowMultiLine
                  value={relatedEntityType}
                  label={langStore.SimulationSessionRelatedEntityTypeLabel}
                />
                <ShowMultiLine
                  value={relatedEntityId}
                  label={langStore.SimulationSessionRelatedEntityIdLabel}
                />
                <ShowDateTime
                  value={startedAt}
                  label={langStore.SimulationSessionStartedAtLabel}
                />
                <ShowDateTime
                  value={completedAt}
                  label={langStore.SimulationSessionCompletedAtLabel}
                />
                <ShowReference
                  label={langStore.SimulationSessionTriggeredByLabel}
                  selectedValue={langStore.displayIdByLang(
                    triggeredByValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
